<template>
  <div class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li v-for="item in visibleSidebarItems" :key="item.id" class="nav-item">
        <sidenav-collapse
          v-if="item.path"
          :collapse-ref="item.path"
          :aria-controls="item.path"
          :collapse="false"
          :is-collapsed="isCollapsed"
          :nav-text="item.label"
        >
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">{{ item.icon }}</i>
          </template>
        </sidenav-collapse>

        <a
          v-else-if="item.externalUrl"
          :href="item.externalUrl"
          class="nav-link"
          :target="item.externalTarget || '_blank'"
          rel="noreferrer noopener"
          :title="item.title"
        >
          <div class="text-center d-flex align-items-center justify-content-center" :class="stIsRTL ? ' ms-2' : 'me-2'">
            <i class="material-icons-round opacity-10 fs-5">{{ item.icon }}</i>
          </div>
          <span
            class="nav-link-text"
            :style="getLinkTextStyle()"
          >
            {{ item.label }}
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex/dist/vuex.cjs.js";
import SidenavCollapse from "./SidenavCollapse.vue";

// const DEFAULT_SIDEBAR_ITEMS = [
//   {
//     id: "admin",
//     label: "Admin",
//     path: "admin",
//     icon: "dashboard",
//     order: 1
//   },
//   {
//     id: "volunteer",
//     label: "Volunteer",
//     path: "volunteer",
//     icon: "checklist",
//     order: 2
//   },
//   {
//     id: "admin-tools",
//     label: "Admin Tools",
//     path: "admin-tools",
//     icon: "build_circle",
//     order: 3
//   },
//   {
//     id: "setup",
//     label: "Setup",
//     path: "setup",
//     icon: "settings",
//     order: 4
//   },
//   {
//     id: "change-password",
//     label: "Change My Password",
//     path: "change-password",
//     icon: "lock_reset",
//     order: 5
//   },
//   {
//     id: "calendar",
//     label: "Calendar",
//     path: "calendar",
//     icon: "calendar_month",
//     order: 6
//   },
//   {
//     id: "request-assistance",
//     label: "Request Assistance",
//     path: "request-assistance",
//     icon: "help",
//     order: 7
//   },
//   {
//     id: "join-organization",
//     label: "Join Organization",
//     path: "join-organization",
//     icon: "corporate_fare",
//     order: 8
//   },
//   {
//     id: "setup-organization",
//     label: "Setup Organization",
//     path: "setup-organization",
//     icon: "manage_accounts",
//     order: 9
//   },
//   {
//     id: "help-docs",
//     label: "Help Docs",
//     icon: "info",
//     externalUrl: "https://www.churchscheduling.com/knowledge-base/",
//     order: 10
//   }
// ];

const stripLeadingSlashes = (value) => (typeof value === "string" ? value.replace(/^\/+/, "") : value);

const normalizeSidebarItem = (item) => {
  const label = item.label || item.name || "Navigation Item";
  const pathCandidate = item.path || item.routePath || item.collapseRef;
  const sanitizedPath = stripLeadingSlashes(pathCandidate);
  const idValue = item.id || sanitizedPath || label.toLowerCase().replace(/\s+/g, "-");
  return {
    id: idValue,
    label,
    path: sanitizedPath,
    icon: item.icon || "chevron_right",
    externalUrl: item.externalUrl || null,
    externalTarget: item.externalTarget || (item.externalUrl ? "_blank" : null),
    title: item.title || label,
    order: Number(item.order ?? item.priority ?? 0),
    roles: Array.isArray(item.roles) ? item.roles : [],
    requiresAdmin: Boolean(item.requiresAdmin)
  };
};

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
    isCollapsed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SidenavCollapse
  },
  computed: {
    ...mapGetters(["stSessionData", "stSidebarRoutes", "stIsRTL"]),
    hasLocation() {
      return Boolean(this.stSessionData?.locationid);
    },
    isAdmin() {
      return Boolean(this.stSessionData?.isAdminInLocation);
    },
    userRole() {
      if (this.isAdmin && this.hasLocation) {
        return "admin";
      }
      if (!this.isAdmin && this.hasLocation) {
        return "volunteer";
      }
      return "user";
    },
    normalizedSidebarItems() {
      const apiItems = Array.isArray(this.stSidebarRoutes?.sidebar) ? this.stSidebarRoutes.sidebar : [];
      return apiItems.map((item) => normalizeSidebarItem(item)).sort((a, b) => a.order - b.order);
    },
    visibleSidebarItems() {
      return this.normalizedSidebarItems.filter(
        (item) =>
          this.shouldDisplayItem(item) &&
          (item.path || item.externalUrl)
      );
    }
  },
  methods: {
    ...mapActions(["fetchSidebarRoutes"]),
    shouldDisplayItem(item) {
      if (item.requiresLocation && !this.hasLocation) {
        return false;
      }
      if (item.requiresAdmin && !this.isAdmin) {
        return false;
      }
      const roles = item.roles?.length ? item.roles : [];
      if (roles.length && !roles.includes("all")) {
        if (!roles.includes(this.userRole)) {
          return false;
        }
      }
      return true;
    },
    getLinkTextStyle() {
      return {
        opacity: this.isCollapsed ? 0 : 1,
        width: this.isCollapsed ? 0 : "auto",
        overflow: this.isCollapsed ? "hidden" : "visible"
      };
    },
    async ensureSidebarRoutes() {
      if (!this.stSidebarRoutes) {
        try {
          await this.fetchSidebarRoutes();
        } catch (error) {
          console.warn("Failed to load sidebar data:", error);
        }
      }
    }
  },
  mounted() {
    this.ensureSidebarRoutes();
  }
};
</script>